import React from 'react';
import { ApolloError } from '@apollo/client';

import { AudienceForMembershipFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';
import { TableField, DataTable, Row } from '@occc/ui-design-system';

type AudiencesProps = {
  audiences: AudienceForMembershipFragment[] | undefined;
  loading: boolean;
  error?: ApolloError;
  onAudienceClick: (id: string) => void;
  paginationProps: IPaginationProps;
};

const makeFields: (audience: AudienceForMembershipFragment) => TableField[] = (audience) => [
  {
    label: 'Name',
    value: audience.name,
  },
  {
    label: 'Description',
    value: audience.description,
  },
];

const Audiences: React.FC<AudiencesProps> = (props) => {
  const { audiences, loading, error, onAudienceClick, paginationProps } = props;
  const headers = [{ label: 'Name' }, { label: 'Description' }];

  const rows: Row[] | null | undefined = audiences?.map((audience) => {
    const fields = makeFields(audience);
    return {
      key: audience.uuid,
      fields,
      onClick() {
        onAudienceClick(audience.uuid);
      },
    };
  });

  return (
    <DataTable
      headers={headers}
      rows={rows}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};

export default Audiences;
